import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Highcharts from 'highcharts'
import { BAR_CHART_COLORS } from '../../Helpers/ChartConstants.js'
import { formatDateStandard } from '../../../../global/formatters/string-formatter.js'

class PerformancePremiumDiscount extends Component {
  constructor(props) {
    super(props)

    this.state = {
      premiumDiscLabel:
        this.props.premiumDiscountDetail.premiumDiscountLabels[0],
      premiumDiscountData: '',
      premiumDiscountDataLine: '',
    }
  }

  componentDidMount() {
    const { premiumDiscDailyData } = this.props.premiumDiscountDetail
    this.getSelectedPremiumDiscount()
    this.getPremiumDiscountDataLine(
      this.state.premiumDiscLabel,
      premiumDiscDailyData
    )
  }

  renderIntervalDropDown = () => {
    const { premiumDiscounts } = this.props.premiumDiscountDetail

    return premiumDiscounts
      .filter((interval) => {
        return (
          interval &&
          interval.premiumDiscountData &&
          interval.premiumDiscountData.some(
            (basisPoint) => basisPoint.values > 0
          )
        )
      })
      .map((interval) => (
        <option
          key={interval.premiumDiscountLabel}
          value={interval.premiumDiscountLabel}
        >
          {interval.premiumDiscountLabel}
        </option>
      ))
  }

  handleIntervalChange = (event) => {
    event.preventDefault()
    const value = event.target.value

    this.setState(
      {
        premiumDiscLabel: value,
      },
      this.getDataCallback
    )
  }

  getDataCallback = () => {
    const { premiumDiscDailyData } = this.props.premiumDiscountDetail

    this.getSelectedPremiumDiscount()
    this.getPremiumDiscountDataLine(
      this.state.premiumDiscLabel,
      premiumDiscDailyData
    )
  }

  callDataFunctions = () => {
    const { premiumDiscDailyData } = this.props.premiumDiscountDetail

    this.getSelectedPremiumDiscount()
    this.getPremiumDiscountDataLine(
      this.state.premiumDiscLabel,
      premiumDiscDailyData
    )
  }

  getSelectedPremiumDiscount = () => {
    let preStatePremDiscData
    const premiumDiscLabel = this.state.premiumDiscLabel
    const premiumDiscountDetails =
      this.props.premiumDiscountDetail.premiumDiscounts

    premiumDiscountDetails.map((premiumDiscount) => {
      if (premiumDiscLabel === premiumDiscount.premiumDiscountLabel) {
        preStatePremDiscData = premiumDiscount.premiumDiscountData
      }
    })

    this.setPreStatePremDiscData(preStatePremDiscData)
  }

  setPreStatePremDiscData = (preStateData) => {
    let value = []
    let basisPoints = []
    let finalChartData = {}

    preStateData.map((dataPoint) => {
      basisPoints.push(dataPoint.basisPoints)
      value.push(Number(dataPoint.values))
    })

    finalChartData.name = this.state.premiumDiscLabel
    finalChartData.data = value
    finalChartData.basisPoints = basisPoints
    this.setState(
      {
        premiumDiscountData: finalChartData,
      },
      this.chartCallBack
    )
  }

  getQuarterOfYearUtil = (date) => {
    const month = date.getMonth() + 1

    return Math.ceil(month / 3)
  }

  sortByDateUtil = (array) => {
    // array.forEach(dataPoint => {
    //   // IE does not support format of date provided from service. need to add T
    //   dataPoint.asOfDate = dataPoint.asOfDate.replace(' ', 'T')
    // })

    array.sort((a, b) => new Date(a.asOfDate) - new Date(b.asOfDate))
  }

  getQuarterYear = (premiumDiscLabel) => {
    const { premiumDiscountAsofDate } = this.props.premiumDiscountDetail
    const currentQuarter = this.getQuarterOfYearUtil(
      new Date(premiumDiscountAsofDate)
    )
    const availableLabels = [
      'Quarter to date',
      'First',
      'Second',
      'Third',
      'Fourth',
    ]
    const currentYear = new Date(premiumDiscountAsofDate).getFullYear()

    let quarterYearInput = {
      year: 0,
      quarter: null,
    }

    availableLabels.forEach(function (label, index) {
      if (premiumDiscLabel.indexOf(label) >= 0) {
        if (index === 0) {
          quarterYearInput.quarter = currentQuarter
        } else {
          quarterYearInput.quarter = index
        }
      }
    })

    if (premiumDiscLabel.indexOf((currentYear - 1).toString()) >= 0) {
      quarterYearInput.year = currentYear - 1
    } else {
      quarterYearInput.year = currentYear
    }

    return quarterYearInput
  }

  getPremiumDiscountDataLine = (premiumDiscLabel, premiumDiscDaily) => {
    const quarterYearInput = this.getQuarterYear(premiumDiscLabel)
    const currentYear = new Date().getFullYear()
    let data = []

    this.sortByDateUtil(premiumDiscDaily)

    premiumDiscDaily.forEach((dailyPoint) => {
      const dailyYear = new Date(dailyPoint.asOfDate).getFullYear()
      const dailyQuarter = this.getQuarterOfYearUtil(
        new Date(dailyPoint.asOfDate)
      )

      if (quarterYearInput.quarter === null && dailyYear === currentYear - 1) {
        data.push(dailyPoint)
      }

      if (
        quarterYearInput.year === dailyYear &&
        quarterYearInput.quarter === dailyQuarter
      ) {
        data.push(dailyPoint)
      }
    })
    this.setPremiumDiscountDataLine(data)
  }

  setPremiumDiscountDataLine = (lineData) => {
    let premiumDiscountDataLine = {}
    let data = []

    lineData.forEach((dataPoint) => {
      let eachPoint = []

      eachPoint.push(new Date(dataPoint.asOfDate).getTime())
      eachPoint.push(parseInt(dataPoint.basisPoints))
      data.push(eachPoint)
    })

    premiumDiscountDataLine.data = data
    premiumDiscountDataLine.name = this.state.premiumDiscLabel

    this.setState({
      premiumDiscountDataLine: premiumDiscountDataLine,
    })
  }

  chartCallBack = () => {
    this.renderBarChart(this.state.premiumDiscountData)
    this.renderLineChart(this.state.premiumDiscountDataLine)
  }

  renderBarChart(premiumDiscount) {
    const seriesData = [premiumDiscount]

    Highcharts.chart('premium-discount-chart', {
      chart: {
        spacing: [10, 0, 10, 0],
        style: {
          fontFamily: 'Franklin Gothic Condensed',
          fontSize: '14px',
        },
        type: 'bar',
      },
      colors: BAR_CHART_COLORS,
      title: {
        text: 'Frequency of Magnitude',
        align: 'center',
      },
      xAxis: {
        categories: premiumDiscount.basisPoints,
        title: {
          text: 'Premium or Discount (Basis Points)',
          style: {
            fontSize: '14px',
          },
          labels: {
            overflow: 'justify',
          },
        },
        crosshair: { color: 'rgba(35, 31, 32, 0.05)' },
        gridLineColor: 'rgba(35, 31, 32, 0.10)',
        lineWidth: 0,
        tickColor: 'rgba(35, 31, 32, 0)',
        labels: {
          style: {
            color: 'rgba(35, 31, 32, 0.60)',
            fontSize: '14px',
          },
        },
      },
      yAxis: {
        min: 0,
        title: {
          text: 'Number of Days',
          align: 'middle',
          style: {
            fontSize: '14px',
          },
        },
        tickInterval: 1,
        gridLineColor: 'rgba(35, 31, 32, 0.10)',
        lineWidth: 0,
        minorTicks: true,
        minorTickInterval: 0.2,
        labels: {
          style: {
            color: 'rgba(35, 31, 32, 0.60)',
            fontSize: '14px',
          },
          overflow: 'justify',
        },
      },
      tooltip: {
        enabled: true,
      },
      plotOptions: {
        bar: {
          dataLabels: {
            enabled: false,
          },
          borderWidth: 0,
          pointPadding: 0,
          states: {
            hover: {
              brightness: 0,
            },
          },
        },
      },
      series: seriesData,
      legend: {
        enabled: false,
      },
      credits: {
        enabled: false,
      },
    })
  }

  renderLineChart(premiumDiscountDataLine) {
    const seriesData = premiumDiscountDataLine

    Highcharts.chart('premium-discount-line-chart', {
      chart: {
        spacing: [10, 0, 10, 0],
        style: {
          fontFamily: 'Franklin Gothic Condensed',
          fontSize: '14px',
        },
        type: 'line',
      },
      title: {
        text: 'Trend Over Time',
        align: 'center',
      },
      yAxis: {
        title: {
          text: 'Premium or Discount (Basis Points)',
          align: 'middle',
        },
      },
      xAxis: {
        // title: {
        //   text: 'Time',
        //   align: 'middle'
        // },
        // categories: premiumDiscountDataLine.time,
        type: 'datetime',
        labels: {
          formatter: function () {
            const oneMonth = 1000 * 60 * 60 * 24 * 31
            const min = this.chart.options.series[0].data[0][0]
            const max =
              this.chart.options.series[0].data[
                this.chart.options.series[0].data.length - 1
              ][0]
            const diff = max - min

            if (diff <= oneMonth || isNaN(diff)) {
              return Highcharts.dateFormat('%b %e', this.value)
            } else {
              return Highcharts.dateFormat('%b', this.value)
            }
          },
        },
        tickPositioner: function () {
          const oneDay = 1000 * 60 * 60 * 24
          const oneMonth = oneDay * 31
          const periodLength = this.dataMax - this.dataMin
          const periodLengthDays = Math.ceil(periodLength / oneDay)
          const dataMinDate = new Date(this.dataMin)

          let positions = []
          let tick = Math.floor(this.dataMin)
          let increment = getIncrementer()

          if (dataMinDate.getDate() != 1) {
            const month = dataMinDate.getMonth()
            const year = dataMinDate.getFullYear()
            tick = new Date(year, month, 1).getTime()
          }

          function getIncrementer() {
            if (periodLength <= oneMonth) {
              if (periodLengthDays >= 0 && periodLengthDays <= 10) {
                return oneDay
              } else if (periodLengthDays > 10 && periodLengthDays <= 20) {
                return oneDay * 2
              } else {
                return oneDay * 3
              }
            } else {
              getMultiMonthTicks()
            }
          }

          function getMultiMonthTicks() {
            let currentMonth = dataMinDate.getMonth()

            positions.push(tick)

            seriesData.data.map((point) => {
              const date = new Date(point[0])
              const month = date.getMonth()
              const year = date.getFullYear()

              if (month !== currentMonth) {
                positions.push(new Date(year, month, 1).getTime())

                currentMonth += 1
              }
            })
          }

          if (increment) {
            for (tick; tick - increment <= this.dataMax; tick += increment) {
              positions.push(tick)
            }
          }

          return positions
        },
      },
      plotOptions: {
        series: {
          marker: {
            enabled: false,
          },
        },
      },
      series: [
        {
          name: seriesData.name,
          data: (function () {
            let data = []
            // if only one data point, enable marker
            if (seriesData.data.length <= 1) {
              data.push({
                x: seriesData.data[0][0],
                y: seriesData.data[0][1],
                marker: {
                  enabled: true,
                },
              })
              return data
            } else {
              return seriesData.data
            }
          })(),
        },
      ],
      colors: BAR_CHART_COLORS,
      credits: {
        enabled: false,
      },
      tooltip: {
        enabled: true,
        headerFormat:
          '<h4 class="u-marginBottom2gu">{point.key:%m/%d/%Y}</h4><br>',
      },
      legend: {
        enabled: false,
      },
    })
  }

  renderDate = () => {
    const { premiumDiscountAsofDate } = this.props.premiumDiscountDetail
    const lastYear = (new Date().getFullYear() - 1).toString()

    return this.state.premiumDiscLabel !== lastYear
      ? 'as of ' + formatDateStandard(premiumDiscountAsofDate)
      : ''
  }

  render() {
    const { etfPremDiscMessage } = this.props

    return (
      <div id="premium-discount-holder">
        <div id="ampf-trace-loaded-section-performance-premium-discount-holder">
          <div className="Grid Grid--alignMiddle u-flexJustifyBetween u-marginBottom4gu">
            <div className="Content u-sizeFit u-sm-paddingBottom3gu u-sm-sizeFull">
              <h3 className="u-marginBottom0">
                <>
                  Premium/Discount{' '}
                  <span className="u-sm-paddingTop1gu u-sm-block">
                    {' '}
                    {this.renderDate()}
                  </span>
                </>
              </h3>
            </div>
            <div
              id="premium-discount-dropdown"
              className="u-sizeFit u-flex u-sm-sizeFull"
            >
              <div className="Dropdown u-marginLeft2gu">
                <select
                  className="Dropdown-menu u-inlineBlock"
                  id="premium-discount-time-dropdown"
                  onChange={this.handleIntervalChange}
                >
                  {this.renderIntervalDropDown()}
                </select>
              </div>
            </div>
          </div>
          <>
            <div
              id="premium-discount-chart"
              className="u-paddingBottom8gu"
            ></div>
            <div
              id="premium-discount-line-chart"
              className="u-paddingBottom6gu"
            ></div>
            {etfPremDiscMessage && etfPremDiscMessage.message && (
              <p className="Disclaimer-text u-paddingBottom6gu">
                {etfPremDiscMessage.message}
              </p>
            )}
          </>
        </div>
      </div>
    )
  }
}

PerformancePremiumDiscount.propTypes = {
  premiumDiscountDetail: PropTypes.object.isRequired,
}

export default PerformancePremiumDiscount
